import { tv } from "@fanka/tailwind-variants";
import { clsx } from "clsx";

export const INPUT_CLASS_NAME = tv({
  base: clsx(
    "border-grayScale-200 w-full rounded-[6px] border px-[20px] py-[13px] outline-none",
    // focus
    "focus:border-2 focus:border-grayScale-400",
    // disabled
    "disabled:cursor-not-allowed disabled:border-grayScale-300 disabled:bg-grayScale-100 disabled:text-base-disabled",
  ),
  variants: {
    error: {
      true: "enabled:border-functional-danger hover:enabled:bg-functional-danger-light focus:bg-functional-danger-light",
      false: "hover:enabled:border-grayScale-400",
    },
    fullHeight: {
      true: "h-full",
      false: "h-[160px]",
    },
    block: {
      true: "",
      false: "max-w-[800px]",
    },
  },
});
